import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";

const SeoHeader = () => {
  const [inputData, setInputData] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    const pages = {
      home: "/",
      domain: "/domain",
      "domain booking": "/domain-booking",
      "domain available": "/domain-available",
      "domain transfer": "/domain-transfer",
      "domain book": "/domain-booking",
      hosting: "/hosting-service",
      "shared hosting": "/shared-hosting-provider",
      "wordpress hosting": "/wordpress-hosting-services",
      "dedicated hosting": "/dedicated-hosting-services",
      "vps hosting": "/vps-hosting-services",
      security: "/web-security-services",
      "standard ssl": "/standard-ssl",
      "wildcard ssl": "/wildcard-ssl",
      "organization validation ssl": "/organization-validation-ssl",
      "extended validation ssl": "/extented-validation-ssl",
      email: "/email-hosting-provider",
      "google workspace": "/google-workspace-service-provider",
      microsoft: "/microsoft-365-service-provider",
      "rediff mail": "/rediff-mail",
      branding: "/branding-agency",
      "branding consulting firm": "/branding-consulting-firm",
      "branding strategy consultant": "/brand-strategy-consultant",
      "brand positioning agency": "/brand-positioning-agency",
      "brand identity agency": "/brand-identity-agency",
      "branding communication agency": "/branding-communication-agency",
      "performance marketing company": "/performance-marketing-company",
      "social media marketing agency": "/social-media-marketing-agency",
      "search engine marketing agency": "/search-engine-marketing-agency",
      "organic marketing agency": "/organic-marketing-agency",
      "search engine optimization services": "/search-engine-optimization-services",
      "search engine optimization": "/search-engine-optimization-services",
      sem: "/search-engine-optimization-services",
      "social media optimization agency": "/social-media-optimization-agency",
      "creative content agency": "/creative-content-agency",
      "display advertising agency": "/display-advertising-agency",
      "website development company": "/website-development-company",
      "print design": "/print-design-agency",
      "content marketing": "/content-marketing-agency",
      "social media": "/social-media-agency",
      "organics marketing": "/organic-social-media-agency",
      "paid marketing": "/paid-marketing-agency",
      "web development": "/web-development-agency",
      "wordpress development": "/wordpress-development-agency",
      "ecommerce development": "/ecommerce-development-agency",
      gallery: "/our-gallery",
      "case studies": "/case-studies",
      blog: "/blog",
      careers: "/career",
      b2b: "/b2b-digital-marketing-agency",
      b2c: "/b2c-digital-marketing-agency",
      "best digital marketing agency in hyderabad": "/best-digital-marketing-agency-in-hyderabad",
      "digital marketing and branding services in hyderabad": "/digital-marketing-and-branding-services-in-hyderabad",
      contact: "/contact",
    };

    const inputValue = inputData.toLowerCase().trim();
    const matchingPage = Object.keys(pages).find((key) =>
      key.includes(inputValue)
    );

    if (matchingPage) {
      navigate(pages[matchingPage]);
    } else {
      navigate("/");
    }
  };
  return (
    <>
      <header className="header1">
        <nav className="navbar navbar-expand-lg navbar-light bg-white p-0">
          <div className="container-fluid menu-inner1">
            <div className="row collapse navbar-collapse">
              <div className="col-md-12 tab-content" id="myTabContent">
                <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                  <ul className="first-tabs">
                    <li>
                      <a href="https://www.grank.co.in/branding-consulting-firm" style={{ color: 'rgb(67, 111, 232)' }}>Brand Consulting</a>
                      <a href="https://www.grank.co.in/brand-strategy-consultant" style={{ color: 'rgb(67, 111, 232)' }}>Brand Strategy</a>
                      <a href="https://www.grank.co.in/brand-positioning-agency" style={{ color: 'rgb(67, 111, 232)' }}>Brand Positioning</a>
                      <a href="https://www.grank.co.in/brand-identity-agency" style={{ color: 'rgb(67, 111, 232)' }}>Brand Identity</a>
                      <a href="https://www.grank.co.in/branding-communication-agency" style={{ color: 'rgb(67, 111, 232)' }}>Brand Communication</a>
                    </li>
                  </ul>
                </div>
                <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                  <ul className="first-tabs">
                    <li>
                      <a href="https://www.grank.co.in/display-advertising-agency" style={{ color: 'rgb(67, 111, 232)' }}>Display Ads</a>
                      <a href="https://www.grank.co.in/website-development-company" style={{ color: 'rgb(67, 111, 232)' }}>Web Design</a>
                      <a href="https://www.grank.co.in/print-design-agency" style={{ color: 'rgb(67, 111, 232)' }}>Print Design</a>
                      <a href="https://www.grank.co.in/content-marketing-agency" style={{ color: 'rgb(67, 111, 232)' }}>Content Marketing</a>
                    </li>
                  </ul>
                </div>
                <div className="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                  <ul className="first-tabs">
                    <li>
                      <a href="https://www.grank.co.in/search-engine-optimization-services" style={{ color: 'rgb(67, 111, 232)' }}>Search Engine Optimization</a>
                      <a href="https://www.grank.co.in/social-media-optimization-agency" style={{ color: 'rgb(67, 111, 232)' }}>Social Media Optimization</a>
                    </li>
                  </ul>
                </div>
                <div className="tab-pane fade" id="Booking" role="tabpanel" aria-labelledby="booking-tab">
                  <ul className="first-tabs">
                    <li>
                      <a href="https://www.grank.co.in/search-engine-marketing-agency" style={{ color: 'rgb(67, 111, 232)' }}>Search Engine Marketing</a>
                      <a href="https://www.grank.co.in/social-media-marketing-agency" style={{ color: 'rgb(67, 111, 232)' }}>Social-Media Marketing</a>
                    </li>
                  </ul>
                </div>
                <div className="tab-pane fade" id="social" role="tabpanel" aria-labelledby="social-tab">
                  <ul className="first-tabs">
                    <li>
                      <a href="https://www.grank.co.in/organic-social-media-agency" style={{ color: 'rgb(67, 111, 232)' }}>Organic Marketing</a>
                      <a href="https://www.grank.co.in/paid-marketing-agency" style={{ color: 'rgb(67, 111, 232)' }}>Paid Marketing</a>
                    </li>
                  </ul>
                </div>
                <div className="tab-pane fade" id="devlopment" role="tabpanel" aria-labelledby="devlopment-tab">
                  <ul className="first-tabs">
                    <li>
                      <a href="https://www.grank.co.in/wordpress-development-agency" style={{ color: 'rgb(67, 111, 232)' }}>WordPress Development</a>
                      <a href="https://www.grank.co.in/ecommerce-development-agency" style={{ color: 'rgb(67, 111, 232)' }}>Ecommerce Development</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </nav>

        {/* Mobile Menu Starts */}
        <div className="menu-mobile">
          <nav className="navbar navbar-expand-lg navbarbgmob navbar-dark sticky-top">
            <a id="RouterNavLink" href="https://www.grank.co.in/">
              <h5 className="navbar-brand"><img src="/seo-assets/photos/g-rank-white-logo.png" alt="logo" title="logo" /></h5>
            </a>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="collapsibleNavbar">
              <ul className="navbar-nav">
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="aboutDropdown" role="button" data-toggle="dropdown">About Us</a>
                  <ul className="dropdown-menu" aria-labelledby="aboutDropdown">
                    <li><a className="dropdown-item" href="https://www.grank.co.in/about">About</a></li>
                    <li className="dropdown-submenu">
                      <a className="dropdown-item dropdown-toggle" href="#">Industries</a>
                      <ul className="dropdown-menu">
                        <li className="dropdown-submenu">
                          <a className="dropdown-item dropdown-toggle" href="#">B2B</a>
                          <ul className="dropdown-menu">
                            <li><a className="dropdown-item" href="https://www.grank.co.in/b2b-digital-marketing-agency">All</a></li>
                            <li><a className="dropdown-item" href="https://www.grank.co.in/power-digital-marketing-agency">Power</a></li>
                            <li><a className="dropdown-item" href="https://www.grank.co.in/hardware-digital-marketing-agency">Hardware</a></li>
                            <li><a className="dropdown-item" href="https://www.grank.co.in/automotive-digital-marketing-agency">Automotive</a></li>
                            <li><a className="dropdown-item" href="https://www.grank.co.in/tech-digital-marketing-agency">Technology</a></li>
                            <li><a className="dropdown-item" href="https://www.grank.co.in/manufacturing-digital-marketing-agency">Manufacturing</a></li>
                            <li><a className="dropdown-item" href="https://www.grank.co.in/raw-material-digital-marketing-agency">Raw Material</a></li>
                          </ul>
                        </li>
                        <li className="dropdown-submenu">
                          <a className="dropdown-item dropdown-toggle" href="#">B2C</a>
                          <ul className="dropdown-menu">
                            <li><a className="dropdown-item" href="https://www.grank.co.in/b2c-digital-marketing-agency">All</a></li>
                            <li><a className="dropdown-item" href="https://www.grank.co.in/realestate-digital-marketing-agency">Real Estate</a></li>
                            <li><a className="dropdown-item" href="https://www.grank.co.in/healthcare-digital-marketing-agency">Health Care</a></li>
                            <li><a className="dropdown-item" href="https://www.grank.co.in/ecommerce-digital-marketing-agency">e-Commerce</a></li>
                            <li><a className="dropdown-item" href="https://www.grank.co.in/lifestyle-digital-marketing-agency">Lifestyle</a></li>
                            <li><a className="dropdown-item" href="https://www.grank.co.in/interior-furniture-digital-marketing-agency">Interiors & Furniture</a></li>
                            <li><a className="dropdown-item" href="https://www.grank.co.in/education-digital-marketing-agency">Education</a></li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/industries">Industries</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/case-studies">Case Studies</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/blog">Blogs</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/contact">Contact</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/career">Careers</a></li>
                  </ul>
                </li>

                {/* Branding Dropdown */}
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="brandingDropdown" role="button" data-toggle="dropdown">Branding</a>
                  <ul className="dropdown-menu" aria-labelledby="brandingDropdown">
                    <li><a className="dropdown-item" href="https://www.grank.co.in/branding-agency">All</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/branding-consulting-firm">Brand Consulting</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/brand-strategy-consultant">Brand Strategy</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/brand-positioning-agency">Brand Positioning</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/brand-identity-agency">Brand Identity</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/branding-communication-agency">Brand Communication</a></li>
                  </ul>
                </li>

                {/* Performance Marketing */}
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="perfDropdown" role="button" data-toggle="dropdown">Performance Marketing</a>
                  <ul className="dropdown-menu" aria-labelledby="perfDropdown">
                    <li><a className="dropdown-item" href="https://www.grank.co.in/performance-marketing-company">All</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/search-engine-marketing-agency">Search Engine Marketing</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/social-media-marketing-agency">Social Media Marketing</a></li>
                  </ul>
                </li>

                {/* Organic Marketing */}
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="orgDropdown" role="button" data-toggle="dropdown">Organic Marketing</a>
                  <ul className="dropdown-menu" aria-labelledby="orgDropdown">
                    <li><a className="dropdown-item" href="https://www.grank.co.in/organic-marketing-agency">All</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/search-engine-optimization-services">Search Engine Optimization</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/social-media-optimization-agency">Social Media Optimization</a></li>
                  </ul>
                </li>

                {/* Creative & Content */}
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="creativeDropdown" role="button" data-toggle="dropdown">Creative & Content</a>
                  <ul className="dropdown-menu" aria-labelledby="creativeDropdown">
                    <li><a className="dropdown-item" href="https://www.grank.co.in/creative-content-agency">All</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/display-advertising-agency">Display Ads</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/website-development-company">Web Design</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/print-design-agency">Print Design</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/content-marketing-agency">Content Marketing</a></li>
                  </ul>
                </li>

                {/* Social Media */}
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="socialMenuDropdown" role="button" data-toggle="dropdown">Social Media</a>
                  <ul className="dropdown-menu" aria-labelledby="socialMenuDropdown">
                    <li><a className="dropdown-item" href="https://www.grank.co.in/social-media-agency">All</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/organic-social-media-agency">Organic Marketing</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/paid-marketing-agency">Paid Marketing</a></li>
                  </ul>
                </li>

                {/* Web Development */}
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="webDevDropdown" role="button" data-toggle="dropdown">Web Development</a>
                  <ul className="dropdown-menu" aria-labelledby="webDevDropdown">
                    <li><a className="dropdown-item" href="https://www.grank.co.in/web-development-agency">All</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/wordpress-development-agency">Wordpress Development</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/ecommerce-development-agency">e-Commerce Development</a></li>
                  </ul>
                </li>

                {/* Domain */}
                <li className="nav-item"><a className="nav-link" href="https://www.grank.co.in/domain">Domain</a></li>

                {/* Hosting */}
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="hostingDropdown" role="button" data-toggle="dropdown">Hosting</a>
                  <ul className="dropdown-menu" aria-labelledby="hostingDropdown">
                    <li><a className="dropdown-item" href="https://www.grank.co.in/hosting-service">All</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/shared-hosting-provider">Shared Hosting</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/wordpress-hosting-services">Wordpress Hosting</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/dedicated-hosting-services">Dedicated Hosting</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/vps-hosting-services">VPS Hosting</a></li>
                  </ul>
                </li>

                {/* Security */}
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="securityDropdown" role="button" data-toggle="dropdown">Security</a>
                  <ul className="dropdown-menu" aria-labelledby="securityDropdown">
                    <li><a className="dropdown-item" href="https://www.grank.co.in/web-security-services">All</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/standard-ssl">Standard SSL</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/organization-validation-ssl">OV SSL</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/extented-validation-ssl">EV SSL</a></li>
                  </ul>
                </li>

                {/* Email */}
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="emailDropdown" role="button" data-toggle="dropdown">Email</a>
                  <ul className="dropdown-menu" aria-labelledby="emailDropdown">
                    <li><a className="dropdown-item" href="https://www.grank.co.in/email-hosting-provider">All</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/google-workspace-service-provider">Google Workspace</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/microsoft-365-service-provider">Microsoft 365</a></li>
                    <li><a className="dropdown-item" href="https://www.grank.co.in/rediff-mail">Rediff</a></li>
                  </ul>
                </li>
              </ul>
            </div>  
          </nav>
        </div>

        <nav className="menu-desktop navbar navbar-expand-lg navbar-light back-ground-color p-0">
          <div className="container-fluid menu-inner">
            <a id="RouterNavLink" href="https://www.grank.co.in/">
              <h5 className="navbar-brand"><img src="/seo-assets/photos/g-rank-white-logo.png" alt="logo" title="logo" /></h5>
            </a>

            <div className="collapse navbar-collapse">
              <ul className="navbar-nav nav m-auto" id="myTab" role="tablist">
                <li className="nav-item">
                  <span className="nav-link show active" id="home-tab" data-toggle="tab" data-target="#home" type="button" role="tab" aria-controls="home" aria-selected="false">
                    <img className="nav-link-img" src="/seo-assets/photos/black-shadow.png" alt="G-Rank" title="grank" />
                    <a href="https://www.grank.co.in/branding-agency" style={{ color: 'rgb(255, 255, 255)' }}>BRANDING</a>
                  </span>
                </li>
                <li className="nav-item">
                  <span className="nav-link" id="Booking-tab" data-toggle="tab" data-target="#Booking" type="button" role="tab" aria-controls="Booking" aria-selected="false">
                    <img className="nav-link-img" src="/seo-assets/photos/black-shadow.png" alt="G-Rank" title="grank" />
                    <a href="https://www.grank.co.in/performance-marketing-company" style={{ color: 'rgb(255, 255, 255)' }}>PERFORMANCE MARKETING</a>
                  </span>
                </li>
                <li className="nav-item">
                  <span className="nav-link" id="contact-tab" data-toggle="tab" data-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false">
                    <img className="nav-link-img" src="/seo-assets/photos/black-shadow.png" alt="G-Rank" title="grank" />
                    <a href="https://www.grank.co.in/organic-marketing-agency" style={{ color: 'rgb(255, 255, 255)' }}>ORGANIC MARKETING</a>
                  </span>
                </li>
                <li className="nav-item">
                  <span className="nav-link" id="profile-tab" data-toggle="tab" data-target="#profile" type="button" role="tab" aria-controls="Profile" aria-selected="false">
                    <img className="nav-link-img" src="/seo-assets/photos/black-shadow.png" alt="G-Rank" title="grank" />
                    <a href="https://www.grank.co.in/creative-content-agency" style={{ color: 'rgb(255, 255, 255)' }}>CREATIVE &amp; CONTENT</a>
                  </span>
                </li>
                <li className="nav-item">
                  <span className="nav-link" id="social-tab" data-toggle="tab" data-target="#social" type="button" role="tab" aria-controls="social" aria-selected="false">
                    <img className="nav-link-img" src="/seo-assets/photos/black-shadow.png" alt="G-Rank" title="grank" />
                    <a href="https://www.grank.co.in/social-media-agency" style={{ color: 'rgb(255, 255, 255)' }}>SOCIAL MEDIA</a>
                  </span>
                </li>
                <li className="nav-item">
                  <span className="nav-link" id="devlopment-tab" data-toggle="tab" data-target="#devlopment" type="button" role="tab" aria-controls="devlopment" aria-selected="true">
                    <img className="nav-link-img" src="/seo-assets/photos/black-shadow.png" alt="G-Rank" title="grank" />
                    <a href="https://www.grank.co.in/web-development-agency" style={{ color: 'rgb(254, 255, 255)' }}>WEB DEVELOPMENT</a>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>

      <section className="section-top">
        <div className="pt-bottom-header bgwhite">
          <div className="container-fluid">
            <div className="row pt15 pb10 dno">
              <div className="col-7 col-md-5 col-lg-5 search-div">
                <form className="search-box-form" onSubmit={handleSubmit}>
                  <button type="submit" className="login-btn">
                    <IconButton color="primary">
                      <SearchIcon />
                    </IconButton>
                  </button>
                  <input
                    className="login-inp"
                    type="text"
                    id="inputData"
                    name="inputData"
                    value={inputData}
                    onChange={(e) => setInputData(e.target.value)}
                    required
                    placeholder="search here…"
                  />
                </form>
              </div>

              <div className="col-5 col-md-7 col-lg-7 text-rig">
                <div className="row text-rig">
                  <div className="col-12">
                    <ul className="icon-top-ul">
                      <li><a href="https://www.google.com/partners/agency?id=9737976863" target="_blank" rel="noreferrer"><img src="/seo-assets/photos/google-partner-big.png" alt="Google Premier Partner" className="img-fluid" title="Google Premier Partner" /></a></li>
                      <li><a href="https://www.facebook.com/business/partner-directory/search?city=Hyderabad&country=IN" target="_blank" rel="noreferrer"><img src="/seo-assets/photos/meta-partner-big.png" alt="Meta Business Partner" className="img-fluid" title="Meta Business Partner" /></a></li>
                      <li><a href="https://workspace.google.com/" target="_blank" rel="noreferrer"><img src="/seo-assets/photos/google-workspace-big.png" alt="Google Workspace Partner" className="img-fluid" title="Google Workspace Partner" /></a></li>
                      <li><a href="https://cloud.google.com/" target="_blank" rel="noreferrer"><img src="/seo-assets/photos/google-cloud-big.png" alt="Google Cloud Partner" className="img-fluid" title="Google Cloud Partner" /></a></li>
                      <li><a href="https://www.microsoft.com/" target="_blank" rel="noreferrer"><img src="/seo-assets/photos/microsoft-logo.png" alt="Microsoft Cloud Solution Provider" className="img-fluid" title="Microsoft Cloud Solution Provider" /></a></li>
                      <li><a href="https://www.rediff.com/" target="_blank" rel="noreferrer"><img src="/seo-assets/photos/rediff.jpg" alt="Rediff Partner" className="img-fluid" title="Rediff Partner" /></a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="second-menu">
          <div className="container">
            <div className="ruby-menu-demo-header mobile-none">
              <div className="ruby-wrapper">
                <ul className="ruby-menu">
                  <li><a href="https://www.grank.co.in/about">ABOUT US</a>
                    <ul>
                      <li className="arrow-div"><a href="https://www.grank.co.in/industries">Industries</a>
                        <ul>
                          <li className="arrow-div2"><a href="https://www.grank.co.in/b2b-digital-marketing-agency">B2B</a>
                            <ul>
                              <li><a href="https://www.grank.co.in/power-digital-marketing-agency">power</a></li>
                              <li><a href="https://www.grank.co.in/hardware-digital-marketing-agency">HardWare</a></li>
                              <li><a href="https://www.grank.co.in/automotive-digital-marketing-agency">automotive</a></li>
                              <li><a href="https://www.grank.co.in/tech-digital-marketing-agency">tech</a></li>
                              <li><a href="https://www.grank.co.in/manufacturing-digital-marketing-agency">Manufacturing</a></li>
                              <li><a href="https://www.grank.co.in/raw-material-digital-marketing-agency">raw material</a></li>
                            </ul>
                            <span className="ruby-dropdown-toggle"></span>
                          </li>
                          <li className="arrow-div3"><a href="https://www.grank.co.in/b2c-digital-marketing-agency">B2C</a>
                            <ul>
                              <li><a href="https://www.grank.co.in/realestate-digital-marketing-agency">Real Estate</a></li>
                              <li><a href="https://www.grank.co.in/healthcare-digital-marketing-agency">Healthcare</a></li>
                              <li><a href="https://www.grank.co.in/ecommerce-digital-marketing-agency">E-Commerce</a></li>
                              <li><a href="https://www.grank.co.in/lifestyle-digital-marketing-agency">Lifestyle</a></li>
                              <li><a href="https://www.grank.co.in/interior-furniture-digital-marketing-agency">Interior Furniture</a></li>
                              <li><a href="https://www.grank.co.in/education-digital-marketing-agency">Education</a></li>
                            </ul>
                            <span className="ruby-dropdown-toggle"></span>
                          </li>
                        </ul>
                        <span className="ruby-dropdown-toggle"></span>
                      </li>
                      <li><a href="https://www.grank.co.in/case-studies">case studies</a></li>
                      <li><a href="https://www.grank.co.in/blog">blog</a></li>
                      <li><a href="https://www.grank.co.in/contact">Contact</a></li>
                      <li><a href="https://www.grank.co.in/career">career</a></li>
                    </ul>
                    <span className="ruby-dropdown-toggle"></span>
                  </li>
                  <li><a href="https://www.grank.co.in/domain">Domain</a><span className="ruby-dropdown-toggle"></span></li>
                  <li><a href="https://www.grank.co.in/hosting-service">Hosting</a>
                    <ul>
                      <li><a href="https://www.grank.co.in/shared-hosting-provider">Shared Hosting</a></li>
                      <li><a href="https://www.grank.co.in/wordpress-hosting-services">WordPress Hosting</a></li>
                      <li><a href="https://www.grank.co.in/dedicated-hosting-services">Dedicated Hosting</a></li>
                      <li><a href="https://www.grank.co.in/vps-hosting-services">VPS Hosting</a></li>
                    </ul>
                    <span className="ruby-dropdown-toggle"></span>
                  </li>
                  <li><a href="https://www.grank.co.in/web-security-services">Security</a>
                    <ul>
                      <li><a href="https://www.grank.co.in/standard-ssl">Standard SSL</a></li>
                      <li><a href="https://www.grank.co.in/organization-validation-ssl">Organization Validation SSL</a></li>
                      <li><a href="https://www.grank.co.in/extented-validation-ssl">Extented Validation SSL</a></li>
                    </ul>
                    <span className="ruby-dropdown-toggle"></span>
                  </li>
                  <li><a href="https://www.grank.co.in/email-hosting-provider">Email</a>
                    <ul>
                      <li><a href="https://www.grank.co.in/google-workspace-service-provider">Google Workspace</a></li>
                      <li><a href="https://www.grank.co.in/microsoft-365-service-provider">Microsoft office 365</a></li>
                      <li><a href="https://www.grank.co.in/rediff-mail">Rediff Mail</a></li>
                    </ul>
                    <span className="ruby-dropdown-toggle"></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SeoHeader;
